export const enquiryTypes = [
  {
    iso: "dontKnow",
    name:
      "Prośba o informacje o produkcie (techniczna/cena/dostępność) - NIE ZNAM numeru części",
  },
  {
    iso: "know",
    name:
      "Prośba o informacje o produkcie (techniczna/cena/dostępność) - ZNAM numer części",
  },
  {
    iso: "sponsor",
    name: "Prośba o sponsoring",
  },
  {
    iso: "other",
    name: "Inne pytania i komentarze",
  },
];

export const driveStyles = [
  {
    iso: "daily",
    name: "Codzienna jazda",
  },
  {
    iso: "commercial",
    name: "Pojazd komercyjny",
  },
  {
    iso: "towing",
    name: "4WD / Holowanie",
  },
  {
    iso: "armoured",
    name: "Pojazd opancerzony",
  },
  {
    iso: "motorsport",
    name: "Sport motorowy",
  },
];
